export const SPEAKER_DELETE_RESET = 'SPEAKER_DELETE_RESET';
export const SPEAKER_DELETE_SET_ERROR = 'SPEAKER_DELETE_SET_ERROR';
export const SPEAKER_DELETE_SET_DELETED = 'SPEAKER_DELETE_SET_DELETED';
export const SPEAKER_DELETE_TOGGLE_LOADING = 'SPEAKER_DELETE_TOGGLE_LOADING';



// WEBPACK FOOTER //
// ./src/store/modules/speaker/delete/mutation_types.js